<template>
  <div class="profile-grid">
    <addresses />
    <card-payment />
    <order-history />
  </div>
</template>

<script>
import CardPayment from "./part/card-payment";
import Addresses from "./part/addresses";
import OrderHistory from "./part/order-history";

export default {
  name: "route-my-account",
  components: {OrderHistory, CardPayment, Addresses}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/client/route-my-account.vue